module.exports = __webpack_public_path__ + "img/logo_anima.cb1c62b6.png";